import { render, staticRenderFns } from "./ePOS.vue?vue&type=template&id=07fbefc8&scoped=true"
import script from "./ePOS.vue?vue&type=script&lang=js"
export * from "./ePOS.vue?vue&type=script&lang=js"
import style0 from "./ePOS.vue?vue&type=style&index=0&id=07fbefc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbefc8",
  null
  
)

export default component.exports